export default __webpack_public_path__ + "img/e8049e65c49ce687cff1bf71dfa6a5d0.woff2";